import styled from '@emotion/styled'
import { spacing } from '@retailer-platform/shared-components'

export const CollectionFormInputWrapper = styled.div({
  width: 320,
  marginRight: spacing.X24,
})
